/**
 * Loading skeleton component for better UX during data loading
 */

export function LoadingSkeleton({ count = 3 }: { count?: number }) {
  return (
    <div className="list">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="skeleton-item">
          <div className="skeleton-content">
            <div className="skeleton-line skeleton-title" />
            <div className="skeleton-line skeleton-meta" />
          </div>
          <div className="skeleton-actions">
            <div className="skeleton-button" />
            <div className="skeleton-button" />
          </div>
        </div>
      ))}
    </div>
  );
}

